export interface IMember
{
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  thumbnailUrl: string;
  phone: string;
  primaryCategory: string;
  categoryList: Array<string>;
  biography: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string
  city: string;
  state: string;
  zipCode: string;
  email: string;
  websiteUrl: string;
}

export interface IMemberList<T extends IMember>
{
  members: Array<T>;
}

export interface IDirectoryState<T extends IMember>
{
  updating: boolean;
  filterFunction: any;
  memberList: Array<T>;
  filteredMemberList: Array<T>;

  nameFilter: string;
  businessFilter: string;
  categoryFilter: string;

  dispatch: any;
  currentPage: number;
}

export const defaultDirectoryModel: IDirectoryState<IMember> = {
  updating: false,
  filterFunction: () => { return true; },
  memberList: [],
  filteredMemberList: [],

  nameFilter: '',
  businessFilter: '',
  categoryFilter: '',

  dispatch: null,
  currentPage: 0
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/classes.ts